/******/ (() => { // webpackBootstrap
var isDefined = customElements.get('localization-form');

if (!isDefined) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.thing = 0;

      this.elements = {
        input: this.querySelector('input[name="language_code"],input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }


    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      const clickedItem = event.currentTarget;
      
      // Handle combined country/language selector
      const countryInput = form.querySelector('input[name="country_code"]');
      const localeInput = form.querySelector('input[name="locale_code"]');
      
      if (clickedItem.dataset.country && countryInput) {
        countryInput.value = clickedItem.dataset.country;
      }
      
      if (clickedItem.dataset.locale && localeInput) {
        localeInput.value = clickedItem.dataset.locale;
      }
      
      // Fallback to original behavior if using single value
      if (!clickedItem.dataset.country && this.elements.input) {
        this.elements.input.value = clickedItem.dataset.value;
      }
      
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = !event.relatedTarget?.classList?.contains('disclosure__item_el');
      if (shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
/******/ })()
;